import { render } from "./ActionSendFbMessenger.vue?vue&type=template&id=e197138e"
import script from "./ActionSendFbMessenger.vue?vue&type=script&lang=ts"
export * from "./ActionSendFbMessenger.vue?vue&type=script&lang=ts"
script.render = render

export default script